import EmulationTokenRecord from "models/view-models/emulation-token-record";
import ServiceFactory from "utilities/services/service-factory";

const baseEndpoint = "/admin/support/tokens";
const resourceEndpoint = `${baseEndpoint}/:id`;
const resourceType = EmulationTokenRecord;

const EmulationService = {
    create: ServiceFactory.create(resourceType, baseEndpoint),

    delete: ServiceFactory.delete(resourceEndpoint),
};

export default EmulationService;
